import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  scope: "row",
  class: "test-properties"
}
const _hoisted_2 = ["title"]

import { useTranslate } from '@/hooks/translate.hook';
import {TestModel} from '@/models/test.model';

export interface TestProps {
  test: TestModel,
  selected: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Test',
  props: {
    test: {},
    selected: { type: Boolean }
  },
  setup(__props: any) {

const {test, selected} = __props
const t = useTranslate()

function getTestType(test: TestModel) {
  if (test.requireCamera && test.faceDetection) {
    return {
      icon: 'fa-solid fa-masks-theater',
      hover: t('page.list.test.type.face')
    }
  }

  if (test.requireCamera) {
    return {
      icon: 'fa-solid fa-camera',
      hover: t('page.list.test.type.camera')
    }
  }

  if (test.showAnswers) {
    return {
      icon: 'fa-solid fa-list-check',
      hover: t('page.list.test.type.activity')
    }
  }

  return {
    icon: 'fa-solid fa-list',
    hover: t('page.list.test.type.regular')
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("tr", {
    key: _ctx.test.testId,
    class: _normalizeClass((_ctx.selected)? 'test-row table-active' : 'test-row')
  }, [
    _createElementVNode("th", _hoisted_1, [
      _createElementVNode("i", {
        class: _normalizeClass(getTestType(_ctx.test).icon),
        title: getTestType(_ctx.test).hover
      }, null, 10, _hoisted_2)
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("span", null, _toDisplayString(_ctx.test.title), 1)
    ])
  ], 2))
}
}

})